import * as React from 'react';
import { localCalendarDay } from './schedule';
import type { CalendarDay } from './schedule';

/**
 * The viewer's device calendar day, re-read at local midnight and whenever the tab becomes visible
 * again (a sleeping laptop does not run its timers), so a tab left open across a holiday changes theme.
 */
export function useCalendarDay(): CalendarDay {
  const [day, setDay] = React.useState(() => localCalendarDay(new Date()));
  React.useEffect(() => {
    const refresh = () =>
      setDay((prev) => {
        const next = localCalendarDay(new Date());
        return next.year === prev.year && next.month === prev.month && next.day === prev.day ? prev : next;
      });
    let timer: ReturnType<typeof setTimeout>;
    const scheduleMidnight = () => {
      const now = new Date();
      const msToMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime();
      timer = setTimeout(() => {
        refresh();
        scheduleMidnight();
      }, msToMidnight + 1000);
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    scheduleMidnight();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
  return day;
}
